import { createAction } from '@ngrx/store';
export enum EventableAction {
  LoadEventablesRouteData = '[Eventables] Load Eventables Route Data',
}

export const loadEventablesRouteData = createAction(
  EventableAction.LoadEventablesRouteData
);
